import { Injectable } from '@angular/core';
import {Campaign, CampaignList} from './campaign';
import {BaseService} from '../base/base.service';
import {CampaignSerializer} from 'src/app/campaigns/campaign.serializer';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CampaignService extends BaseService<Campaign, CampaignList> {

  constructor(http: HttpClient) {
    super(http);
    this.endpoint = 'campaigns' ;
    this.serializer = new CampaignSerializer();
  }
}
